<template>
  <div>
    <StatusBadge
      v-if="item.userPasswordEnabled"
      class="primaryAuthStatusBadge"
      :data-test-id="$testId('login-creds-badge')"
      text="LOGIN CREDENTIALS"
    />
    <StatusBadge
      v-if="item.userCertEnabled || item.deviceCertEnabled"
      :data-test-id="$testId('certificates-badge')"
      text="CERTIFICATES"
    />
  </div>
</template>

<script>
import {
  StatusBadge,
} from '@jumpcloud/ui-components';

export default {
  name: 'RadiusPrimaryAuthenticationStatusBadge',

  components: { StatusBadge },

  props: {
    item: {
      default: () => ({ item: { } }),
      type: Object,
    },
  },
};
</script>

<style scoped>
  .primaryAuthStatusBadge {
    margin-right: 1em;
  }
  </style>
